import { Card, CardContent } from "@/components/ui/card";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTextColorClass } from "@/components/ui/text-coloring";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import { openIntercom } from "@/utils/intercomUtils";
import { supportLabels } from "@/i18n";
import { getLanguage } from "@/utils/languageUtils";
import { useNativeWebChatPrompt } from "@/hooks/useNativeWebChatPrompt";
import { openIntercomMessenger } from "@/lib/intercom/intercomMessenger";

export const ContactCards = () => {
  const { baseText, subtleText } = useTextColorClass();
  const supportLabels_i18n = supportLabels(getLanguage());
  const { requestChat, isNative } = useNativeWebChatPrompt();

  const handleStartChat = () => {
    if (isNative) {
      requestChat();
      return;
    }
    try {
      openIntercomMessenger();
    } catch {
      openIntercom();
    }
  };

  return (
    <div className="glass-card rounded-xl border border-border/60 p-4 sm:p-6 my-6 sm:my-8">
      <div className="flex items-center gap-2 mb-4">
        <h2 className={`text-lg sm:text-xl font-semibold ${baseText}`}>
          {supportLabels_i18n.contact?.title}
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="rounded-lg border-border/60 bg-background/80">
          <CardContent className="p-4 sm:p-6">
            <div className="flex flex-col items-start">
              <div className="flex items-center mb-1">
                <Phone className="h-5 w-5 text-[#D4AF37] mr-2" />
                <h3 className={`text-lg font-semibold ${baseText}`}>
                  {supportLabels_i18n.contact?.callUs?.title}
                </h3>
              </div>
              <p className={`text-sm mb-4 ${subtleText}`}>
                {supportLabels_i18n.contact?.callUs?.description}
              </p>
              <a
                href="tel:086690500"
                className={`text-lg font-semibold ${baseText} hover:underline cursor-pointer`}
              >
                {supportLabels_i18n.contact?.callUs?.phone}
              </a>
            </div>
          </CardContent>
        </Card>

        <Card className="rounded-lg border-border/60 bg-background/80">
          <CardContent className="p-4 sm:p-6">
            <div className="flex flex-col items-start">
              <div className="flex items-center mb-1">
                <Mail className="h-5 w-5 text-[#D4AF37] mr-2" />
                <h3 className={`text-lg font-semibold ${baseText}`}>
                  {supportLabels_i18n.contact?.emailUs?.title}
                </h3>
              </div>
              <p className={`text-sm mb-4 ${subtleText}`}>
                {supportLabels_i18n.contact?.emailUs?.description}
              </p>
              <a
                href="mailto:kundservice@bilenia.se"
                className={`text-lg font-semibold ${baseText} hover:underline cursor-pointer`}
              >
                {supportLabels_i18n.contact?.emailUs?.email}
              </a>
            </div>
          </CardContent>
        </Card>

        <Card className="rounded-lg border-border/60 bg-background/80">
          <CardContent className="p-4 sm:p-6">
            <div className="flex flex-col items-start">
              <div className="flex items-center mb-1">
                <MessageCircle className="h-5 w-5 text-[#D4AF37] mr-2" />
                <h3 className={`text-lg font-semibold ${baseText}`}>
                  {supportLabels_i18n.contact?.chat?.title}
                </h3>
              </div>
              <p className={`text-sm mb-4 ${subtleText}`}>
                {supportLabels_i18n.contact?.chat?.description}
              </p>
              <Button
                onClick={handleStartChat}
                variant="outline"
                className="w-full"
              >
                {supportLabels_i18n.contact?.chat?.startChat}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
